function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { UtmParamsSchema } from "../models/index.js";
/**
 * Utility class for parsing utm params.
 *
 * @author @Mxs2019
 */ var UtmParamUtil = /*#__PURE__*/ function() {
    "use strict";
    function UtmParamUtil() {
        _class_call_check(this, UtmParamUtil);
    }
    _create_class(UtmParamUtil, null, [
        {
            key: "parseUtmParamsFromRequest",
            value: function parseUtmParamsFromRequest(request) {
                return this.parseUtmParamsInternal(new URL(request.url).searchParams);
            }
        },
        {
            key: "parseUtmParamsFromSearchParams",
            value: function parseUtmParamsFromSearchParams(searchParams) {
                return this.parseUtmParamsInternal(searchParams);
            }
        },
        {
            key: "parseUtmParamsInternal",
            value: function parseUtmParamsInternal(searchParams) {
                var params = {};
                var utmParamMappings = {
                    utm_source: "utmSource",
                    utm_medium: "utmMedium",
                    utm_campaign: "utmCampaign",
                    utm_content: "utmContent",
                    utm_term: "utmTerm"
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(utmParamMappings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), urlParam = _step_value[0], schemaParam = _step_value[1];
                        var value = searchParams.get(urlParam);
                        if (value !== null && value !== "") {
                            params[schemaParam] = value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var parsed = UtmParamsSchema.safeParse(params);
                if (!parsed.success) {
                    return {};
                }
                return parsed.data;
            }
        }
    ]);
    return UtmParamUtil;
}();
export default UtmParamUtil;
